export enum PhoneNumberTypes {
    CELL = 'Cell',
    HOME = 'Home',
    OFFICE = 'Office',
    FAX = 'Fax',
    PAGER = 'Pager',
    MAIN = 'Main',
    DIRECT = 'Direct',
}

export const phoneNumberTypesList: string[] = Object.values(PhoneNumberTypes);
